import * as firebase from 'firebase';

// Your web app's Firebase configuration
const config = {
    apiKey: "AIzaSyBi-kyBSy4B1xsdCfXl25M0IlaFZUsAjF0",
    authDomain: "tic-tac-toe-d0202.firebaseapp.com",
    databaseURL: "https://tic-tac-toe-d0202.firebaseio.com",
    projectId: "tic-tac-toe-d0202",
    storageBucket: "tic-tac-toe-d0202.appspot.com",
    messagingSenderId: "530442651160",
    appId: "1:530442651160:web:004b4478d6232e9813256d",
    measurementId: "G-KW5F76Z92L"
};

firebase.initializeApp(config);
